<!-- <div class="page_heading">
  <div class="container">
      <h2>{{title}}</h2>
  </div>
</div>
<app-banner [BannerData]="bannerArray"></app-banner>


<section class="our-business">
  <div class="row  our-business-heading mt-0">
    <div class="col-sm-12">
      <h2>services</h2>
    </div>
  </div>
<ng-container *ngFor="let data of ourProducts | keyvalue let i=index;">
        <div *ngIf="i % 2 == 0" class="row content-one" [class.mt-0]="i>1">
          <div class="col-sm-6 center-line">
            <img loading="lazy" src="{{data.value.img}}" alt="product" width="400">
            <div class="s-no">
              <span>{{i+1}}</span>
            </div>
          </div>
          <div class="col-sm-6 googleRanking">
            <div class="float">
              <h3>{{data.value.heading}}</h3>
              <p>{{data?.value?.features}}</p>
            </div>
          </div>
        </div>
        <div *ngIf="i % 2 != 0" class="row content-one mt-0">
          <div class="col-sm-6 localseoservice" >
            <div class="float-l">
              <h3>{{data.value.heading}}</h3>
              <p class="one-p">{{data?.value?.features}}</p>
            </div>
          </div>
          <div class="col-sm-6 center-line-l">
            <img loading="lazy" src="{{data.value.img}}" alt="product" width="400">
            <div class="s-no-l">
              <span>{{i+1}}</span>
            </div>
          </div>
        </div>
</ng-container>
  </section>

<section class="our-business-mobile">
  <div class="row  our-business-heading mt-0">
    <div class="col-sm-12">
      <h2>{{detail?.heading}} Features</h2>
    </div>
  </div>
  <ng-container *ngFor="let data of ourProducts | keyvalue let i=index;">
  <div *ngIf="i % 2 == 0" class="row content-one mt-5">
    <div class="col-sm-6 center-line">
      <img loading="lazy" src="{{data.value.img}}" alt="product">
      <div class="s-no">
        <span>{{i+1}}</span>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="container float">
        <h3>{{data.value.heading}}</h3>
        <p>{{data?.value?.features}}</p>
      </div>
    </div>
  </div>
  <div *ngIf="i % 2 != 0" class="row content-one mt-0">
    <div class="col-sm-6 center-line-l">
      <img loading="lazy" src="{{data.value.img}}" alt="product">
      <div class="s-no-l">
        <span>{{i+1}}</span>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="container float">
        <h3>{{data.value.heading}}</h3>
        <p class="one-p">{{data?.value?.features}}</p>
      </div>
    </div>
  </div>
</ng-container>
</section>
-------------------------our-business-mobile Section end----------------- -->

<div class="page_heading">
  <div class="container">
    <h2>Privacy Policy</h2>
  </div>
</div>

<section class="rs-legal" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--br"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-spark" style="--sx: 8%; --sy: 30%; --sd: 0.6s"></span>
  </div>

<div class="container my-5 rs-legal__doc" rsReveal="up">
  <h1>Privacy Policy for The Lobster App</h1>
  <p>Thank you for using <b>The Lobster App</b>. Your privacy matters to us. This Privacy Policy explains how we collect, use, and protect your information when you use our app.
  </p>
  <h3>1. What The Lobster App Does</h3>
  <p>The Lobster App is designed to help users monitor the <b>UV index</b> at their current location. To do this, the app determines your approximate geographic location (latitude and longitude) based on your <b>IP address</b>.
  </p>
  <h3>2. What Information We Collect</h3>
  <p>We do not request or access your device’s GPS or precise location. Instead, we collect:</p>
  <ul>
    <li><b>Approximate Location (Latitude and Longitude):</b> This is obtained using a third-party API that estimates your location based on your IP address.
    </li>
  </ul>
 
  <h3>3. How We Use Your Information</h3>
  <p>
    We use your approximate location for a single purpose:</p>
    <ul>
      <li>To retrieve the <b>UV index</b> for your current location via a weather or UV index API.</li>
    </ul>
    <p>We do <b>not</b> use this data for any other reason.</p>
    <h3>4. Data Storage and Sharing</h3>
  <ul>
    <li>
      <b>No Data Storage:</b> We do not store your IP address or location data.
    </li>
    <li>
      <b>No Third-Party Sharing (Beyond API Use):</b> Your IP is sent only to the <b>location lookup API</b> to retrieve latitude and longitude, and then to the <b>UV index API</b> to fetch the UV index. This data is <b>not stored, sold</b>, or <b>shared</b> for any other purpose.
    </li>
    <li>
     <b>No Advertising or Analytics Use:</b>  Your data is not used for marketing, tracking, or behavioral analytics.
    </li>
  </ul>
  <h3>5. Your Control</h3>
  <ul>
    <li>You can use the app without granting any special permissions. No access to your device’s precise location is required.</li>
    <li>If you prefer not to use IP-based location, you may disable internet access, but the app may not function properly.</li>
  </ul>
  <h3>6. Security</h3>
  <p>We use secure HTTPS connections when communicating with external APIs to protect your data in transit.</p>
  <h3>7. Changes to This Policy</h3>
  <p>We may update this Privacy Policy periodically. Updates will be posted here with an updated effective date. Continued use of the app constitutes acceptance of any changes.
  </p>
  <h3>8. Contact Us</h3>
  <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
  📧 <a [href]="'mailto:' + mail">{{ mail }}</a>
</div>
</section>










